import { useAppContext } from '@/AppContext';
import { Message } from '@/pages/chat/components/ChatContainer';
import { getChatMessages } from '@/pages/history/api';
import { RootState } from '@/typings';
import { ElMessage } from '@qsxy/element-plus-react';
import { useRequest } from 'ahooks';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useFetchMessages = () => {
	const loginUser = useSelector<RootState, RootState['user']>(state => state.user ?? {});

	const { conversationTitle } = useAppContext();

	const { runAsync, loading } = useRequest((conversationId: string) => getChatMessages({ userId: loginUser.username, conversationId }), { manual: true });

	const handleMessage = useCallback((message: string) => {
		if (message.indexOf('</think>') === -1) {
			return `${message}</think>无`;
		}
		return message;
	}, []);

	const getMessages = useCallback(
		async (id: string, callback: (messages: Message[]) => void) => {
			try {
				const messages = await runAsync(id);

				if (messages.length > 0) {
					if (!conversationTitle.current) {
						conversationTitle.current = messages[0].query;
					}
					callback?.(
						messages.reduce((prev, item) => {
							return [
								...prev,
								{
									role: 'user',
									content: item.query,
								},
								{
									role: 'assistant',
									content: handleMessage(item.answer),
									conversation: {
										id,
										messageId: item.id,
									},
								},
							];
						}, []),
					);
				} else {
					callback?.([]);
				}
			} catch (error) {
				if (error === 404) {
					ElMessage.error('此会话已删除，无法查看');
					callback([]);
				}
			}
		},
		[conversationTitle, handleMessage, runAsync],
	);

	return { getMessages, handleMessage, loading };
};
